/**
 * API utility functions for HTTP communication.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Returns standard headers for API requests.
 * Includes cache control headers to prevent stale data.
 */
export var getHeaders = function (additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    return (__assign({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache', 'Expires': '0' }, additionalHeaders));
};
